
import EDTooltip from '../../../../../../../BaseComponents/Tooltip/EDTooltip';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { TEDEKBokforderTYPEnum } from '../../../../../../../globalQueryTypes';
import { ValueType } from '../../../../../../../Utils/Formatters/FormatterTypes';

interface IProps {
  value: ValueType;
  displayValue: string;
}

const getLabel = (type: ValueType): string => {
  switch (type) {
    case TEDEKBokforderTYPEnum.BOKFORINGSORDER:
      return 'BFO';
    case TEDEKBokforderTYPEnum.UTANORDNING:
      return 'UA';
    default:
      return 'invalid label';
  }
};

const BokforderTypComp: React.FC<React.PropsWithChildren<IProps>> = props => {
  const displayValue = getLabel(props.value);

  return (
    <EDTooltip title={props.displayValue}>
      <EDTypography bold lineHeight="inherit">
        {displayValue}
      </EDTypography>
    </EDTooltip>
  );
};

export default BokforderTypComp;
